"use client";

import { useLayoutEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * Con layout compartido, Next puede mantener el scroll del documento al cambiar de
 * `/examples`, `/examples/...`, etc. Subimos al inicio en cada pathname bajo este layout.
 * useLayoutEffect corre antes del paint del navegador (mejor que useEffect para esto).
 */
export function ExamplesScrollToTopOnNavigate() {
  const pathname = usePathname();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
